'use strict'

import { hasOwn } from './helpers'

/**
 * @param {Object} plugin
 * @description Installs a new plugin into the Vue instance bound
 * to the window object.
 */
export const use = (plugin) => {
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin)
  }
}

/**
 * @param {Vue} Vue
 * @param {Object} component
 * @description Registers a new component into the given Vue instance.
 */
export const registerComponent = (Vue, component) => {
  if (!hasOwn(Vue._context.components, component.name)) {
    Vue.component(component.name, component)
  }
}

/**
 * @param {Vue} Vue
 * @param {String} property
 * @param {Object} component
 * @description Registers a new programmatic component into the given Vue
 * instance i.e modal windows, toast messages ect.
 */
export const registerComponentProgrammatic = (Vue, property, component) => {
  if (!Vue.config.$AkeroCore) Vue.config.$AkeroCore = {}
  Vue.config.$AkeroCore[property] = component
}
